import { EDIT, VIEW, DELETE } from '@/helpers/enums/table-actions'


export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Обязательность',
    value: 'is_required',
    sortable: false,
    width: 120,
  },
  {
    text: 'Кол-во Мер',
    value: 'base_events_count',
    sortable: false,
    width: 100,
  },
  /*
  {
    text: 'Минимальное кол-во Мер',
    value: 'min_events_count',
    sortable: false,
    width: 80,
  },
  {
    text: 'Подтверждено?',
    value: 'is_confirmed',
    sortable: false,
    width: 130,
  },
  */
])

export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  VIEW,
  DELETE,
])
